module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageCareers.elements) ? _c('div', {
    staticClass: "landing-careers"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageCareers.elements,
      "heroHome": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collage-bg"
  }, [_c('section', {
    staticClass: "careers-info container",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageCareers.elements.description_title) ? _c('h3', {
    staticClass: "title-medium"
  }, [_vm._v("\n        " + _vm._s(_vm.pageCareers.elements.description_title.value) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.pageCareers.elements.description_text) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageCareers.elements.description_text.value)
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', {
    staticClass: "careers-slider"
  }, [_c('carousel', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "hidden-xs",
    attrs: {
      "id": "slider-dektop",
      "navigationEnabled": false,
      "navigationNextLabel": '',
      "navigationPrevLabel": '',
      "perPage": 1,
      "paginationActiveColor": '#8E4C3B',
      "paginationColor": '#dedede',
      "navigationClickTargetSize": 5,
      "paginationPadding": 5,
      "paginationSize": 10
    }
  }, [_vm._l((_vm.videosSliders), function(slide) {
    return (_vm.videosSliders.length) ? [_c('slide', [_c('div', {
      staticClass: "embed-container"
    }, [_c('iframe', {
      attrs: {
        "src": 'https://player.vimeo.com/video/' +
          slide.vimeo_id.value +
          '?loop=1&title=0&byline=0&portrait=0',
        "width": "640",
        "height": "360",
        "frameborder": "0",
        "allow": "autoplay; fullscreen",
        "allowfullscreen": ""
      }
    })])])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.careersSliders), function(slide) {
    return (_vm.careersSliders.length) ? [_c('slide', {
      style: (_vm.setBackgroundImage(slide.background_image___desktop.value[0].url))
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "copy"
    }, [_c('h3', [_vm._v(_vm._s(slide.title.value))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport",
        value: ({}),
        expression: "{}"
      }]
    }, [_vm._v(_vm._s(slide.description.value))])])]), _vm._v(" "), _c('div', {
      staticClass: "gradient"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": slide.background_image___desktop.value[0].url,
        "alt": slide.background_image___desktop.value[0].name
      }
    })])] : _vm._e()
  })], 2), _vm._v(" "), _c('carousel', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "visible-xs",
    attrs: {
      "id": "slider-mobile",
      "navigationEnabled": false,
      "navigationNextLabel": '',
      "navigationPrevLabel": '',
      "perPage": 1,
      "paginationActiveColor": '#8E4C3B',
      "paginationColor": '#dedede',
      "navigationClickTargetSize": 5,
      "paginationPadding": 5,
      "paginationSize": 10
    }
  }, [_vm._l((_vm.videosSliders), function(slide) {
    return (_vm.videosSliders.length) ? [_c('slide', [_c('div', {
      staticClass: "embed-container"
    }, [_c('iframe', {
      attrs: {
        "src": 'https://player.vimeo.com/video/' +
          slide.vimeo_id.value +
          '?loop=1&title=0&byline=0&portrait=0',
        "width": "640",
        "height": "360",
        "frameborder": "0",
        "allow": "autoplay; fullscreen",
        "allowfullscreen": ""
      }
    })])])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.careersSliders), function(slide) {
    return (_vm.careersSliders.length) ? [_c('slide', {
      style: (_vm.setBackgroundImage(slide.background_image___mobile.value[0].url))
    }, [_c('div', {
      directives: [{
        name: "in-viewport",
        rawName: "v-in-viewport"
      }],
      staticClass: "copy"
    }, [_c('h3', [_vm._v(_vm._s(slide.category.value))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(slide.title.value))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(slide.description.value))])]), _vm._v(" "), _c('div', {
      staticClass: "gradient"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": slide.background_image___mobile.value[0].url,
        "alt": slide.background_image___mobile.value[0].name
      }
    })])] : _vm._e()
  })], 2)], 1), _vm._v(" "), (_vm.pageCareers.elements) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section detail-page"
  }, [_c('div', {
    staticClass: "inside",
    domProps: {
      "innerHTML": _vm._s(_vm.pageCareers.elements.detail_page.value)
    }
  })]) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageCareers.elements.related_words_title) ? _c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center container"
  }, [_vm._v("\n        " + _vm._s(_vm.pageCareers.elements.related_words_title.value) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.pageCareers.elements.related_words_description) ? _c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center container"
  }, [_vm._v("\n        " + _vm._s(_vm.pageCareers.elements.related_words_description.value) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('articles-wrapper', {
    attrs: {
      "boxes": _vm.relatedWorks,
      "isHome": true,
      "boxlimit": 4,
      "pathRoute": '/words',
      "showCategory": true,
      "showViewAll": true
    }
  })], 1)]), _vm._v(" "), (_vm.quote.elements) ? _c('section', {
    staticClass: "content-quote container-fluid col-xs-12"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "quote-text text-center"
  }, [_vm._v("\n        \"" + _vm._s(_vm.quote.elements.quote_text.value) + "\"\n        "), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.quote.elements.author.value) + " ")])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/jobs",
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "btn_orange",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Check our Open Positions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h3', {
    staticClass: "title-medium small-wrapper text-center"
  }, [_vm._v("Our commitment to you includes:")]), _vm._v(" "), _c('ul', {
    staticClass: "benefits"
  }, [_c('li', [_c('span', {
    staticClass: "num"
  }), _vm._v("Flexible Time Off")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num gold"
  }), _vm._v("Hybrid Or Remote Work")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num purple"
  }), _vm._v("Medical Benefits")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num green"
  }), _vm._v("Work Equipment Provided")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }), _vm._v("Development and Bonuses")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num gold"
  }), _vm._v("Travel Opportunities")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num purple"
  }), _vm._v("Facilities In-Office")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num green"
  }), _vm._v("Connectivity Benefits")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num"
  }), _vm._v("Wellness Benefits")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num gold"
  }), _vm._v("Milestones Recognition")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "num purple"
  }), _vm._v("English Classes (LATAM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-wrapper comments"
  }, [_c('p', [_vm._v("*Note: We have benefits and perks that are specific to the type of employment and location.")]), _vm._v(" "), _c('p', [_vm._v("This will be explained in depth during the screening interview.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ad926e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Careers.vue
// module id = 1524
// module chunks = 0